import React, { Component } from 'react';
import { inject } from 'mobx-react';
import AddEditSAMLForm from './form';
import { LdapEditMode } from '../../../services/enums/ldap';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import ErrorDialog from '../../portal/dialogs/errorDialog';

@inject('translationsStore', 'samlStore', 'teamsStore')
export default class AddEditSAMLFormContainer extends Component {

    samlStore = this.props.samlStore;
    validator = this.props.samlStore.validator;
    t = this.props.translationsStore.translate;
    errorDialogTitle;
    errorDialogMessage;

    state = {
        showTeamDialog: false,
        showErrorDialog: false,
        teamFullName: '',
        currentlySelectedTeamId: this.samlStore.defaultTeamId ? this.samlStore.defaultTeamId : -1
    };

    openTeamsDialog = _ => {

        this.props.teamsStore.getAllTeams()
            .then(() => {

                this.setState({
                    showTeamDialog: true
                });
            })
            .catch(err => {
            });
    }

    closeTeamsDialog = _ => {

        this.setState({
            showTeamDialog: false
        });
    }

    onTeamSelect = selectedKeys => {

        this.setState({
            currentlySelectedTeamId: parseInt(selectedKeys[0])
        });        
    }

    teamSelected = _ => {

        this.samlStore.setDefaultTeamId(this.state.currentlySelectedTeamId);
        this.validator.validateDefaultTeamId(this.samlStore.defaultTeamId);

        this.closeTeamsDialog();
    }
    
    triggerToastr = (message, level) => {

        ToastrService.triggerToastr({level, message});
    }

    openErrorDialog = () => {

        this.setState({ 
            showErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            showErrorDialog: false
        }); 
    }

    handlerSuccess = _ => {

        this.samlStore.getAllSAMLIdentityProviders();
        this.samlStore.resetForm();
        this.samlStore.toggleIsEditMode();
        this.props.closeForm();
    }

    post = _ => {

        this.samlStore.post()
            .then(_ => {

                this.handlerSuccess();
            })
            .then(_ => {

                const level = ToastrLevelsEnum.SUCCESS;
                const message = this.t('SAML_IDP_CREATED_SUCCESS_MESSAGE');
                this.triggerToastr(message, level);
            })
            .catch(err => {

                this.errorDialogMessage = this.samlStore.postSAMLIdpErrorMessage;
                this.errorDialogTitle = this.t('ERROR');
                this.openErrorDialog();
            }); 
    }

    put = _ => {

        this.samlStore.put()
            .then(_ => {

                this.handlerSuccess();
            })
            .then(_ => {
                
                const level = ToastrLevelsEnum.SUCCESS;
                const message = this.t('SAML_IDP_UPDATED_SUCCESS_MESSAGE');
                this.triggerToastr(message, level);
            })
            .catch(err => {

                this.errorDialogMessage = this.samlStore.putSAMLIdpErrorMessage;
                this.errorDialogTitle = this.t('ERROR');
                this.openErrorDialog();
            });
    }

    isFormValid = () => {

        return this.validator.validateForm({
            certificateFilename: this.samlStore.certificateFileName,
            issuer: this.samlStore.issuer,
            name: this.samlStore.name,
            loginUrl: this.samlStore.loginUrl,
            logoutUrl: this.samlStore.logoutUrl,
            errorUrl: this.samlStore.errorUrl,
            defaultTeamId: this.samlStore.defaultTeamId,
            isManualManagement: this.samlStore.isManualManagement,
            mapSamlIdpAttributes: this.samlStore.isMappingEnabled,
            teamMappingAttribute: this.samlStore.teamMappingAttribute
        });
    }

    submit = e => {

        e.preventDefault();

        this.validator.resetValidations();

        if (this.isFormValid() === false) {
            
            return;
        }

        const { editMode } = this.props;

        if (editMode === LdapEditMode.add) {
         
            this.post();
        }
        else if (editMode === LdapEditMode.update) {

            this.put();
        }
    }

    render() {

        const { cancelButtonHandler, editMode } = this.props;

        const selectedKeys = this.state.currentlySelectedTeamId ? [`${this.state.currentlySelectedTeamId}`] : [];
        const fullPathName = this.props.teamsStore.getTeamFullName(this.samlStore.defaultTeamId);      

        return(
            [<AddEditSAMLForm
                key={1}
                submit={this.submit}
                cancelButtonHandler={cancelButtonHandler}
                editMode={editMode}
                samlStore={this.samlStore}
                openTeamsDialog={this.openTeamsDialog}
                showTeamDialog={this.state.showTeamDialog}
                closeTeamsDialog={this.closeTeamsDialog}
                onTeamSelect={this.onTeamSelect}
                selectedKeys={selectedKeys}
                teamSelected={this.teamSelected}
                teamFullPathName={fullPathName}
                dataCy={this.props.dataCy}
            />,
            <ErrorDialog 
                key={2}
                show={this.state.showErrorDialog}
                onConfirm={this.closeErrorDialog}
                deleteButtonText={this.t('CLOSE')}
                closeDeleteDialog={this.closeErrorDialog}
                titleText={this.errorDialogTitle}
                contentText={this.errorDialogMessage}
            />]
        );
    }
}